module.exports = __webpack_public_path__ + "img/Subject.bc64e327.png";